import moment from 'moment';

export type CtmAnalyticsModel = {
  adId: string;
  adName: string;
  campaignName: string;
  adsetName: string;
  impressions: number;
  cpm: number;
  reach: number;
  spend: number;
  smAd: boolean;
  costPerConversation?: number;
  conversations?: number;
  trackedConversations?: number;
  uniqueInlineLinkClicks?: number;
  uniqueInlineLinkClickCtr?: number;
  inlineLinkClicks?: number;
  inlineLinkClickCtr?: number;
};

export type CtmAnalyticsQuery = {
  query: string | null;
  parentId: string | null;
  token: string | null;
  range: { since: moment.Moment; until: moment.Moment };
};

export const queryRangeDateFormat = 'YYYY-MM-DD';

export const queryToString = (analyticsQuery: CtmAnalyticsQuery) => {
  const {
    token,
    query,
    parentId,
    range: { since, until },
  } = analyticsQuery;
  const queryPart = query ? `_${query}` : '';
  const parentPart = parentId ? `_${parentId}` : '';
  const tokenPart = token ? `_${token}` : '';
  const rangePart = `_${since.format(queryRangeDateFormat)}|${until.format(
    queryRangeDateFormat,
  )}`;
  return `${parentPart}${rangePart}${queryPart}${tokenPart}`;
};
